import React from "react";
import Chart from "react-apexcharts";

const RevenueChart = () => {
    const options = {
        chart: {
            type: "bar",
            height: 170,
            width: '100%',
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 3,
                columnWidth: "50%",
            },
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
            labels: {
                style: {
                    fontSize: "10px",       // Adjust font size
                    fontFamily: "Manrope",     // Specify font family
                    fontWeight: '600'
                }
            }
        },
        yaxis: {
            tickAmount: 4,
            labels: {
                formatter: (value) => {
                    if (value === 0) return '0';  // Keep 0 as is
                    return `${value / 1000}k`;    // Convert thousands to k format
                },
            },
        },
        tooltip: {
            y: {
                formatter: (value) => {
                    if (value === 0) return '0';  // Keep 0 as is
                    return `$${value / 1000}k`;    // Convert thousands to k format
                },
            },
        },
        fill: {
            colors: ["#007AFF"], // Active blue color
            opacity: 0.5, // Default light opacity
        },
        states: {
            active: { filter: { type: "none" } },
            hover: { filter: { type: "none" } },
        },
    };

    const series = [
        {
            name: "Revenue",
            data: [1000, 2000, 1500, 3000, 4000, 3500, 2500], // Example revenue data
        },
    ];

    return (
        <>
            <Chart options={options} series={series} type="bar" height={170} />
        </>
    );
};

export default RevenueChart;
